<template>
  <div class="purchaseOrder">
    <template v-if="isShowLoading">
      <loading></loading>
    </template>

    <!-- 订单明细 -->

    <Breadcrumb separator=">" :style="{margin: '24px 0'}" >
      <BreadcrumbItem>我的账户</BreadcrumbItem>
      <BreadcrumbItem v-if="this.$route.params.sale === 2 ||this.$route.query.salesOrder ==1">销售管理</BreadcrumbItem>
      <BreadcrumbItem v-if="this.$route.params.sale !== 2 && !this.$route.query.salesOrder">采购管理</BreadcrumbItem>
      <BreadcrumbItem v-if="this.$route.params.sale === 2 || this.$route.query.salesOrder ==1">销售订单</BreadcrumbItem>
      <BreadcrumbItem v-if="this.$route.params.sale === 2 || this.$route.query.salesOrder ==1">销售详情列表</BreadcrumbItem>
      <BreadcrumbItem v-if="this.$route.params.sale !== 2 && !this.$route.query.salesOrder">采购订单</BreadcrumbItem>
      <BreadcrumbItem v-if="this.$route.params.sale !== 2 && !this.$route.query.salesOrder">采购详情列表</BreadcrumbItem>
    </Breadcrumb>
    <table id="customers">
      <tr>
        <th>采购单号：{{orderInfo.mOrid}}</th>
        <th>订单状态：<span>{{orderInfo.strddzt}}</span></th>
      </tr>
      <tr> <td colspan="12">关联销售单号：{{orderInfo.sOrid}}</td> </tr>
      <tr> <td colspan="12">订单金额：￥{{orderInfo.amnt}}</td>  </tr>
    </table>

    <p slot="title" class="cardTitle" ><span>订单明细</span></p>
    <p slot="title" class="amend-cardTitle" v-if="false" >
      <span>订单备注：{{noteContent}}<a @click="btnModifyRemark()">修改备注</a></span>
    </p>

    <Modal title="修改备注" v-model="modifyRemark" :mask-closable="false" @on-ok="confirmModificationRemarks" >
      <div class="Modify-the-remark"></div>
      <detail-form
        :isListPage="true"
        :formDatas="formDatas"
        :formItemList="formItemList1"
        :isBtn="false"
        :btnLabelWidth="100"
        :labelWidth="170"
        :isHasTable='false'
      ></detail-form>
    </Modal>

    <div class="title-name">服务商：{{titleName}}</div>
    <radioTable
      :loading="isLoading"
      :isPage="false"
      :colname="colnames6"
      :total="total"
      :tableData="tableData6"
      :isHideHeader="false"
    ></radioTable>
    <div class="locationWrong">

      <!-- 修改游览日期 -->
      <Button
        @click="btnModifyTourDate()"
        class="btnModifyTourDate" v-show="btn.modifyDate&&distributorType!=1" >修改游览日期</Button>
      <Modal title="修改游览日期" v-model="modifyTourDate" :mask-closable="false" @on-ok="dateSet" >
        <detail-form
          :isListPage="true"
          :formDatas="formDatas"
          :formItemList="formItemList2"
          :isBtn="false"
          :btnLabelWidth="100"
          :labelWidth="100"
          :isHasTable='false'
        ></detail-form>
        <div class="mysaleDate"> 修改游览日期：<DatePicker type="date" v-model="tourValueDate" :options="startTimeOptions" placeholder="请选择日期" style="width: 200px"></DatePicker>
        </div>
      </Modal>

    <!-- 修改预定订单2019.5.20新添加需求 -->
    <Button @click="btnModifyBookingOrder()" class="btnModifyTourDate" v-show="btn.modifyOrder&&distributorType!=1">修改预定订单</Button>
    <!--  修改预定订单   -->
    <Modal v-model="ModalBookingOrder" @on-ok="ModalBookingOrderOk" title="修改预定订单" :closable="true" :mask-closable="false" >

      <detail-form
        :isListPage="true"
        :formDatas="formDatas"
        :formItemList="formItemList3"
        :isBtn="false"
        :btnLabelWidth="200"
        :labelWidth="200"
        :isHasTable='false'
      ></detail-form>

      <div class="serial-number ReviseReservationOrde-block">
        <span class="serial-number-text">预定门票数量<span class="quotes">：</span></span>
        <div class="coutter-wrapper">
          <button type="button" class="subtract" @click="minus()" >-</button>
          <input type="text" value="1" class="quantity" v-model="result" disabled >
          <button type="button" class="plus" @click="plus()" v-bind:style="{'background-color':color}" >+</button>
        </div>
      </div>
      <div class="serial-number ReviseReservationOrde-block quotes-pric">
        <span class="serial-number-text">现支付金额<span class="quotes">：</span></span>
        <span class="serial-number-content">{{numberGagarinMoney.toFixed(2)}}</span>
      </div>
      <div class="ReviseReservationOrder-hint">温馨提示：退订门票相关订单信息在我的退订订单中显示</div> 
    </Modal>

      <Button   @click="instance" v-show="btn.unsubscribe&&distributorType!=1" >全部退订</Button>
      <Button :to="skiprl" target="_blank" type="primary" @click="btnPayNow"  v-show="btn.payment" >立即支付</Button>
    </div>

    <!-- 退订确认框 修改 by liuy 2018-8-29 11:44:55 -->
    <Modal v-model="isUnreg" width="360" >
      <p slot="header" style="color:#5db2ff;" ><span>全部退订</span></p>
      <div style="text-align:center">
        <p style="font-size:16px; line-height:30px;margin-top:10px;">是否全部退订？</p>
      </div>
      <div slot="footer" style="text-align:center" >
        <Button type="primary" :loading="modalLoading" @click="sureEvent" >确定</Button>
        <Button @click="cancelEvent">取消</Button>
      </div>
    </Modal>

    <div class="mySalesDate2">
      <radioTable :loading="isLoading" :isPage="false" :colname="colnames2" :total="total" :tableData="tableData2" ></radioTable>
      <div class="mySalesDate2-table">
        <span class="orderProcessingpaymentAmount">支付金额：<span>￥</span>{{orderInfo.amnt}}</span>
      </div>
    </div>
    <!--  -->
    <!-- 订单处理详情列表 -->
    <p slot="title" class="cardTitle" ><span>订单处理详情列表</span></p>
    <div class="Order-processing-detail-list">
      <span>服务商：{{titleName}}</span>
      <span>订单类型：预定订单</span>
      <span>首次游览日期：{{new Date(tourValueDate).format("yyyy-MM-dd")}}</span>
      <span>支付金额：￥{{listMont}}</span>
    </div>
    <radioTable :loading="isLoading" :colname="colnames3" :isPage="false" :total="total" :tableData="tableData3" ></radioTable>

    <!-- 游客信息4 -->
    <p slot="title" class="cardTitle" > <span>游客信息</span></p>
    <radioTable :loading="isLoading" :colname="colnames4" :isPage="false" :total="total" :tableData="tableData4" ></radioTable>
    <!-- 游客信息5 -->
    <p slot="title" class="cardTitle" > <span>订单跟踪信息</span> </p>

    <radioTable
      :loading="isLoading"
      :colname="colnames5"
      :isPage="false"
      :total="total"
      :tableData="tableData5"
    ></radioTable>
  </div>
</template>

<script>
export default {
  name: "test",
  data () {
    return {
      distributorType: sessionStorage.getItem("distributorType"),
      time: Date.now() - 86400000,
      startTimeOptions: {
        disabledDate: date => {
          return date && date.valueOf() < this.time
        }
      },
      sizeColor: {},
      numShow: false,
      isUnreg: false,
      modalLoading: false, // 退订按钮确定后的加载中状态
      immediatePayment: false,
      btn:{
        unsubscribe:false,//全部退订
        modifyDate:false,//修改游览日期
        modifyOrder:false,//修改预定订单
        payment:false//立即支付
      },
      noteContent: '',//订单备注
      skiprl: '',
      titleName: "",//服务商
      tourValueDate: "",//首次游览日期
      scenicIdIndex: "",
      modifyOrder: false,
      modifyTourDate: false,
      modifyRemark: false,
      modifyContact: false,
      oridParams: "",
      usidParams: "",
      yorderFacilitator: "",
      yorderOrderType: "",
      yorderDate: "",
      yorderMoney: "",
      yorderPayment: "",
      orderInfo:{
        mOrid:'',//供应商单号
        strddzt:'', //订单状态
        sOrid:'',//关联分销商订单号
        amnt:'' ,//订单金额
        scenicId:''//商户ID
      },
      listMont: 0,//支付金额
      listTpmont: 0,
      tpmontUndf: 0,
      total: 0,
      result: 0,
      isShowLoading: false,
      isRadio: true,
      isLoading: false,
      modal10: false,
      animal: "爪哇犀牛",
      ModalBookingOrder:false, // 修改预定订单弹窗
      numberGagarinMoney: 0.0, // 现支付数量
      ticketQuantity:0,// 票数量不可修改
      cPrice:null,
      color: '',
      formDatas: {
        val1: "",
        val2: "",
        val3: "",
        val4: "",
        val5: "",
        val6: "",
        val7: "",
        val8: "",
        val9: "",
        val10: ""
      },
      formItemList: [
        {
          keyName: "val1",
          type: 1,
          label: "联系人姓名"
        },
        {
          keyName: "val2",
          type: 1,
          label: "身份证"
        },
        {
          keyName: "val3",
          type: 1,
          label: "联系电话"
        }
      ],
      formItemList1: [
        {
          keyName: "val4",
          type: 1,
          label: "修改备注"
        }
      ],
      formItemList2: [
        // {
        //   keyNameStart: "val5",
        //   type: 5,
        //   label: "修改游览日期",
        //   double: false,
        // }
      ],
      formItemList3: [
        {
          keyName: "val6",
          type: 8,
          label: "产品名称"
        },
        {
          keyName: "val7",
          type: 8,
          label: "订单编号"
        },
        {
          keyName: "val8",
          type: 8,
          label: "入园时间"
        },
        {
          keyName: "val9",
          type: 8,
          label: "门票价格"
        },
        {
          keyName: "val10",
          type: 8,
          label: "原支付金额"
        }
      ],
      // key值

      colnames2: [
        {
          title: "产品名",
          align: "center",
          width: 150,
          render: (h, params) => {
            return h("div", [ h("span"), params.row.productInfo.sztickettypename ]);
          }
        },
        {
          title: "游览日期",
          width: 100,
          render: (h, params) => {
            return h("div", [h("span"), params.row.orderInfo.stdt]);
          }
        },
        {
          title: "入园时段",
          width: 200,
          render: (h, params) => {
            let {bespeakStartTime} = params.row.productInfo
            if ( bespeakStartTime != null && bespeakStartTime != "" ) {
              return h("div", [ h("span", "游览日期："),`${params.row.productInfo.starttime} - ${params.row.productInfo.bespeakEndTime}`]);
            } else {
              return h("div", [h("span", "景区营业时间内全天有效")]);
            }
          }
        },
        {
          title: "产品",
          width: 157,
          render: (h, params) => {
            return h("div", [ h("span"),`${params.row.productInfo.sztickettypename}[${params.row.productInfo.szcrowdkindname}]`]);
          }
        },
        {
          title: "单价",
          width: 80,
          render: (h, params) => {
            return h("div", [h("span"), '￥' + params.row.orderInfo.price]);
          }
        },
        {
          title: "数量",
          width: 70,
          render: (h, params) => {
            return h("div", [h("span"), params.row.orderInfo.numb]);
          }
        },
        {
          title: "佣金",
          width: 80,
          render: (h, params) => {
            return h("div", [h("span"), `￥${params.row.orderInfo.commision}`]);
          }
        },
        {
          title: "金额",
          width: 100,
          render: (h, params) => {
            return h("div", [h("span"), `￥${params.row.orderInfo.amnt}`]);
          }
        }
      ],
      tableData2: [],

      colnames3: [
        {
          title: "产品名",
          render: (h, params) => {
            return h("div", [
              h("span"),
              params.row.productInfo.sztickettypename
            ]);
          }
        },
        {
          title: "单价",
          width: 100,
          render: (h, params) => {
            return h("div", [h("span"), `￥${ params.row.orderInfo.price}`]);
          }
        },
        {
          title: "数量",
          width: 100,
          render: (h, params) => {
            return h("div", [h("span"), params.row.orderInfo.oldNumb]);
          }
        },
        {
          title: "佣金",
          width: 100,
          render: (h, params) => {
            return h("div", [h("span"), `￥${ params.row.orderInfo.oldCommision}`]);
          }
        },
        {
          title: "金额",
          width: 100,
          render: (h, params) => {
            return h("div", [h("span"), `￥${ params.row.orderInfo.oldAmont}`]);
          }
        }
      ],
      tableData3: [],
      colnames4: [
        {
          title: "姓名",
          key: "tourName"
        },
        {
          title: "证件号码",
          key: "idNumber"
        },
        {
          title: "电话",
          key: "telNumber"
        }
      ],
      tableData4: [],
      colnames5: [
        {
          title: "处理时间",
          key: "dtDate"
        },
        {
          title: "处理信息",
          key: "processDetail"
        },
        {
          title: "处理人",
          key: "usid"
        }
      ],
      tableData5: [],

      colnames6: [
        {
          render: (h, params) => {
            let mlStyle = { marginLeft: "40px"}
            return h("div", [
              h("span", {}, "游览日期："),
              h("span", params.row.orderInfo.stdt),

              h( "span", { style: mlStyle },  "领票人姓名："  ),
              h("span", params.row.orderInfo.ornm),

              h( "span", { style: mlStyle }, "领票人证件号码：" ),
              h("span", params.row.orderInfo.orhm),

              h( "span", { style: mlStyle }, "领票人手机号码：" ),
              h("span", params.row.orderInfo.orph)
            ]);
          }
        }
      ],
      tableData6: []
    };
  },
  async created () {
    // this.mySalesAxios();
    this.isShowLoading = true;
    /* 如果是结算返回则延时5秒 */
    // 20190520 修改 bug刷新跑到采购订单  销售订单添加salesOrder解决
    if (this.$route.params.sale === 2 || this.$route.query.salesOrder ==1) {
      this.sales1();
    } else if (this.$route.fullPath.indexOf("?") === -1 && !this.$route.query.salesOrder) {
      this.oridParams = this.$route.query.orid;
      this.usidParams = this.$route.query.usid;
      this.mySalesAxios();
    } else if (this.$route.params === 1) {
      this.numShow = false
    } else if (this.$route.params === 1) { } else {
      this.isShowLoading = true;
      this.oridParams = this.$route.query.orid;
      this.usidParams = this.$route.query.usid;
      setTimeout(() => {
        this.mySalesAxios();
        // this.isShowLoading = false;
        // return;
      }, );
    };
  },
  beforeMounted () { },
  methods: {
    
    // 采购管理--采购订单--订单详情
    mySalesAxios () {
      this.isShowLoading = true;
      this.$http.get(`${this.baseURL}/ec/distributeOrder/v1/getPurchaseDistributeOrderDetail`,
          {
            params: {
              access_token: sessionStorage.getItem("name"),
              orid: this.$route.query.orid,
              url: window.location.host
            }
          }
        ).then(response => {
          this.isShowLoading = false;
          let {code,msg} = response.data;
           if(code !== 200){
            this.$Modal.error({
              title: "温馨提示",
              content: msg || '请求失败'
            });
            return false;
          }else if (code === 200) {
            if(!response.data.data) return false;
            let {orderInfo,orderFlow,productInfo,tourist} = response.data.data
            this.orderInfo={
              mOrid:orderInfo.cOrid,//供应商单号
              strddzt:orderInfo.strddzt, //订单状态
              sOrid:orderInfo.sOrid,//关联分销商订单号
              amnt:orderInfo.amnt ,//订单金额
              scenicId:orderInfo.scenicId//商户ID
            },
            this.tableData5 = orderFlow;
            let userId = sessionStorage.getItem("userName")
            let newDate = new Date();
            let currDate = new Date(`${newDate.getFullYear()}-${newDate.getMonth() + 1}-${newDate.getDate()} 00:00:00`).getTime();
            let dtstartdate = new Date(orderInfo.dtstartdate).getTime();
            let dtenddate = new Date(orderInfo.dtenddate).getTime();
            
            /**
              1、四种操作：修改游玩日期（A）；全部退订（C）；修改预定订单（D）；立即支付（E）
              2、未付款（00）：只操作 E
              2、已支付（02）、已退订（退款中）（30）：可操作 A、C、D
              3、已支付（02）、已退订（退款中）（30）&& (currDate<=dtstartdate)：可操作 A、C、D
              4、已支付（02）、已退订（退款中）（30）&& (currDate>=dtenddate)：可操作 C、D
              5、已支付（02）、已退订（退款中）（30）&& (dtstartdate<=currDate<=dtenddate)：不存在任何操作
              6、已出票（11）&& (checkNum===0):可操作 C、D 
              7、退订已退款（06）、全退订（27）、退款中（31）、退款失败（33）、失效订单/垃圾作废订单（98）：不存在任何操作
              8、currDate = dtenddate 当天日期有效期同一天不给退票，暂时对C操作做限制
              备注：
              1、inote3：是否是团购票 1是 0否 ； 1->不显示操作 D
              2、oldNumb ==0表示当前的票已经退完，用户不存在任何操作
              3、tourist代表游客信息，有---实名制票，无---非实名制 实名制不显示操作 D  20190705  --Amay
              4、orderInfo.usid下单分销商、userId当前登录分销商 上级分销商不能修改下级分销商下单的状态
            **/
           if(orderInfo.usid == userId){
              if(orderInfo.pmcd=='00'){
              this.btn.payment = (orderInfo.oldNumb == orderInfo.numb)? true :false //立即支付
            }else if((orderInfo.pmcd=='02' || orderInfo.pmcd=='30')&& !(dtstartdate <= currDate && currDate <= dtenddate)){
              // let TDenddate = new Date(`${orderInfo.dtenddate} 23:59:59`).getTime();
              // this.btn.unsubscribe = (orderInfo.oldNumb == orderInfo.numb) && orderInfo.oldNumb!=0 && currDate < TDenddate;//全部退订
              this.btn.unsubscribe = (orderInfo.oldNumb == orderInfo.numb) && orderInfo.oldNumb!=0;//全部退订
              this.btn.modifyDate =!(currDate >= dtenddate) && orderInfo.pmcd !='30' ? true : false;//修改游览日期
              this.btn.modifyOrder = productInfo.inote3 != 1 && orderInfo.oldNumb!=0 && tourist.length==0? true : false;//修改预定订单
            }else if(orderInfo.pmcd=='11' && orderInfo.checkNum==0){
              this.btn.unsubscribe = true;//全部退订
              this.btn.modifyOrder = true;//修改预定订单
            }
           }
            let resData = response.data.data;
            this.scenicIdIndex = resData.orderInfo.stdt
            this.tableData4 = resData.tourist; //游客信息orderInfo;
            this.tableData6 = Array(resData);
            this.tableData2 = Array(resData);
            this.tableData3 = Array(resData);
            this.listMont = resData.orderInfo.oldAmont;//支付金额
            this.formDatas.val1 = resData.orderInfo.ornm; //联系人姓名
            this.formDatas.val2 = resData.orderInfo.orhm; //身份证
            this.formDatas.val3 = resData.orderInfo.orph; //联系电话
            this.tourValueDate =  resData.orderInfo.stdt; //首次游览日期
            this.titleName = resData.productInfo.szscenicname; //服务商
            this.noteContent = resData.orderInfo.note;//订单备注

            let noteDateContent = resData.orderInfo.note;
            noteDateContent = this.formDatas.val4
          } 
        }).catch(error => {
          this.isShowLoading = false;
          return;
        });
    },
    
  // 销售管理--销售订单--详情  
    sales1 () {
      this.isShowLoading = true;
      this.$http.get(`${this.baseURL}/ec/distributeOrder/v1/getSaleDistributeOrderDetail`,
          {
            params: {
              access_token: sessionStorage.getItem("name"),
              orid: this.$route.query.orid,
              url: window.location.host
            }
          }
        ).then(response => {
          this.isShowLoading = false;
          if(response.data.code !== 200){
              this.$common.showMessage(this,response.data.msg,1);
              return false;
          }
          let {orderInfo,orderFlow,productInfo} = response.data.data
          this.orderInfo={
            mOrid:orderInfo.cOrid,//供应商单号
            strddzt:orderInfo.strddzt, //订单状态
            sOrid:orderInfo.sOrid,//关联分销商订单号
            amnt:orderInfo.amnt ,//订单金额
          },
          this.tableData5 = response.data.data.orderFlow;
          let newDate = new Date();
          let currDate = new Date(`${newDate.getFullYear()}-${newDate.getMonth() + 1}-${newDate.getDate()} 00:00:00`).getTime();
          let dtstartdate = new Date(orderInfo.dtstartdate).getTime();
          let dtenddate = new Date(orderInfo.dtenddate).getTime();
          let selaName = this.$route.params.sale;
          let resData = response.data.data;
          this.scenicIdIndex = resData.orderInfo.stdt

          this.tableData4 = resData.tourist;//游客信息orderInfo
          this.tableData6 = Array(resData);
          this.tableData2 = Array(resData);
          this.tableData3 = Array(resData);

          this.listMont = resData.orderInfo.oldAmont;//支付金额
          this.formDatas.val1 = resData.orderInfo.ornm; //联系人姓名
          this.formDatas.val2 = resData.orderInfo.orhm; //身份证
          this.formDatas.val3 = resData.orderInfo.orph; //联系电话
          this.tourValueDate = resData.orderInfo.stdt; //首次游览日期
          this.titleName = resData.productInfo.szscenicname; //服务商
          this.noteContent = resData.orderInfo.note;//订单备注
          let noteDateContent = resData.orderInfo.note;//备注信息
          noteDateContent = this.formDatas.val4
        }).catch(error => {
          this.isShowLoading = false;
          return;
        });
    },

    //立即支付
    btnPayNow () {
      this.isShowLoading = true;
      this.$http.get(`${this.baseURL}/ec/orderManage/v1/orderRePay`, {
        params: {
          access_token: sessionStorage.getItem("name"),
          orid: this.$route.query.orid,
          url: window.location.host
        }
      }).then(response => {
        let {code, msg} = response.data
        if (code !== 200) {
          this.$Modal.error({
            title: "温馨提示",
            content: msg || '请求失败'
          });
          return false;
        } 
        this.skiprl = response.data.data.url;
        window.location.replace(this.skiprl);
        this.isShowLoading = false;
      }).catch(error => {
        this.isShowLoading = false;
        return;
      });
    },

    // 加加减减
    minus () {
      if (this.result !== 0) {
        this.result--;
        this.numberGagarinMoney -= this.cPrice;
        let minusResult = this.result;
        let minusNumberMoney = this.numberGagarinMoney;
        if (this.result == this.ticketQuantity) {
          this.color = '#808080'
        } else {
          this.color = '#4b7ff0';
        }
        if (this.result == 0) {
          this.numberGagarinMoney = 0.00
        }
      }
    },
    plus () {
      if (this.result < this.ticketQuantity) {
        this.result++;
        this.numberGagarinMoney += this.cPrice;
        
        this.color = '#4b7ff0';
        if (this.result == this.ticketQuantity) {
          this.color = '#808080'
        } else {
          this.color = '#4b7ff0';
        }
      }
    },
    // 修改游览日期
    btnModifyTourDate () {
      this.modifyTourDate = true;
    },
    // 获取修改订单弹框详情
    btnModifyBookingOrder(){
      return new Promise((resolve, reject) => {
      this.$http.get(this.baseURL + "/ec/distributeOrder/v1/getDistributeOrderInfo", {
        params: {
          access_token: sessionStorage.getItem("name"),
          orid: this.$route.query.orid,
          usid: this.$route.query.usid,
          url: window.location.host
        }
      }).then(response => {
        this.isShowLoading = false;
        if(response.data.code !==200 ){
          this.$common.showMessage(this,response.data.msg,1);
          reject(response.data.code);
          return false;
        }
        this.ModalBookingOrder = true
        if(!response.data.data) return false;
        let {sztickettypename,orid,stdt,price,amnt,cPrice,numb} = response.data.data;
        this.formDatas.val6 = sztickettypename;
        this.formDatas.val7 = orid;
        this.formDatas.val8 = stdt;
        this.formDatas.val9 = price;
        this.formDatas.val10 = amnt;
        this.cPrice= cPrice;
        this.result = numb // 数量
        this.numberGagarinMoney = numb * cPrice;
        this.ticketQuantity = numb; //票数量（不可修改）
        resolve();
      }).catch(error => {
            this.isShowLoading = false;
            reject('err');
            return;
          });
      })
    },

    //确定修改预定订单详情
    ModalBookingOrderOk(){
      let numb = this.ticketQuantity - this.result;
      let numpri = numb * this.cPrice;
      let paramsData = this.QS.stringify({
        access_token: sessionStorage.getItem("name"),
        orid: this.$route.query.orid,
        usid: sessionStorage.getItem("userName"),
        refundFee: numpri,
        numb: numb
      })
      this.$http.post(`${this.baseURL}/ec/distribute/v1/distributeOrderRefund?${paramsData}` , {}).then(response => {
          this.modalLoading = false;
          if(response.data.code !== 200){
          this.$Modal.error({
              title: '温馨提示',
              content: response.data.msg || '请求失败',
          });
          return false;
        }else if(response.data.code === 200){
          this.$Modal.success({
              title: '温馨提示',
              content: response.data.msg,
              onOk: () => {
                setTimeout(() => {
                  this.$router.go({	name: 'MySalesOrder'})
              },500)
              } 
          });
        }
      }).catch(error => {
          this.modalLoading = false;
      })
    },

    //修改游览日期
    dateSet () {
      this.isShowLoading = true;
      let scenicIdIndex = this.scenicIdIndex;
      let paramsData = this.QS.stringify({
          access_token:sessionStorage.getItem("name"),
          orid:this.$route.query.orid,
          tourDate:new Date(this.tourValueDate).format("yyyy-MM-dd"),//首次游览日期
          usid:sessionStorage.getItem("userName"),
          iscenicid:this.orderInfo.scenicId
      })
      iscenicid:this.orderInfo.scenicId
      this.$http.post(`${this.baseURL}/ec/distribute/v1/distributeOrderUpdateStdt?${paramsData}`).then(response => {
      this.isShowLoading = false;
      let {code,msg} = response.data;
      if(code !== 200){
          this.$Modal.error({
          title: "温馨提示",
          content: msg || '请求失败',
        });
        return false;
      }else if(code === 200){
          this.$Modal.success({
            title: "温馨提示",
            content: '修改成功',
            onOk: () => {
              setTimeout(() => {
                this.mySalesAxios();
              },500);
            }
          });
        } 
      }).catch(error => {
        this.isShowLoading = false;
        return;
      });       
    },

    // 全部退订 
    instance () {
      this.isUnreg = true;
    },
    // 取消退订
    cancelEvent () {
      this.isUnreg = false;
    },
    // 确定退订确定退订
    sureEvent () {
      this.modalLoading = true;
      let queryData = this.QS.stringify({
        access_token:sessionStorage.getItem("name"),
        orid:this.$route.query.orid,
        usid:sessionStorage.getItem("userName"),
        refundFee:this.orderInfo.amnt
      })
      this.$http.post(`${this.baseURL}/ec/distribute/v1/distributeOrderRefund?${queryData}`, {}).then(response => {
        this.mySalesAxios();
        this.modalLoading = false;
        this.isUnreg = false;
        if(response.data.cod !==200){
           this.$Modal.error({
            title: '温馨提示',
            content: response.data.msg || '请求失败' , 
          });
        }else if (response.data.code === 200) {
          this.$common.showMessage(this,response.data.msg,3);
        }
      }).catch(error => {
        this.modalLoading = false;
        this.isUnreg = false;
      })
    },
    //修改备注
    btnModifyRemark () {
      this.modifyRemark = true;
      this.formDatas.val4 = this.noteContent//订单备注
    },
    confirmModificationRemarks () {
      this.isShowLoading = true
      this.$http.get(this.baseURL + '/ec/distribute/v1/updatedistributeNote', {
        params: {
          access_token: sessionStorage.getItem("name"),
          orid: this.$route.query.orid,
          note: this.formDatas.val4,
        }
      }).then((response) => {
        this.isShowLoading = false;
        if(response.data.code !==200){
          this.$common.showMessage(this,response.data.msg,1);
          return false;
        }else if (response.data.code === 200) {
          this.$Modal.success({
            title: "温馨提示",
            content: '修改成功',
            onOk: () => {
              setTimeout(() => {
                this.mySalesAxios();
              }, 500);
            }
          });
        }
        let noteDateContent = response.data.data.orderInfo.note;
        noteDateContent = this.formDatas.val4
        this.isShowLoading = false;
        return;
      }).catch((error) => {
        this.isShowLoading = false;
        return;
      })
    },
  
    // instance() {
    //   this.$Modal.info({
    //     title: "全部退订",
    //     content: "是否全部退订？",
    //     onOk: () => {
    //       setTimeout(() => {
    //       let token = sessionStorage.getItem("name");
    //       let oridName = this.$route.query.orid;
    //       let userName = sessionStorage.getItem("userName");
    //       let refundFeeName =  this.orderAmountText;
    //       this.$http.post(this.baseURL + '/ec/distribute/v1/distributeOrderRefund?access_token=' + token + '&orid=' + oridName + '&usid=' + userName + '&refundFee=' + refundFeeName, {

    //       }).then(response => {
    //         this.mySalesAxios();
    //         if(response.data.code === 200){
    //           this.$common.showMessage(this,response.data.msg,3);
    //         } else if(response.data.code === 400){
    //           this.$common.showMessage(this,response.data.msg,1);
    //         }

    //       }).catch(error => {
    //       })
    //     },500)
    //     }
    //   });
    // },
  }
};
</script>


<style scoped>
/* 修改预定订单操作 */
.serial-number {
  margin-left: 110px;
}
.ReviseReservationOrde-block {
  margin-left: 104px;
  margin-bottom: 40px;
}

.quotes {
  margin-right: 14px;
}
.coutter-wrapper {
  display: inline-block;
}
.coutter-wrapper .subtract,
.coutter-wrapper .plus {
  width: 20px;
  background: #4b7ff0;
  color: #fff;
  border: 0;
  border-radius: 4px;
}
.coutter-wrapper .plus {
  background-color: #808080;
}
.coutter-wrapper .quantity {
  background: none;
  width: 20px;
  border: 0;
  text-align: center;
}
.quotes-pric .quotes {
  margin-right: 15px;
}
.quotes-pric {
  margin-left: 117px;
}
.ReviseReservationOrder-hint {
  text-align: center;
  display: block;
  color: #f54112;
  margin-bottom: 10px;
}
.Modify-the-remark {
  margin-top: 20px;
}
.mysaleDate {
  margin: 30px 0 30px 100px;
}
.mySalesDate2-table {
  border: 1px solid #ccc;
  text-align: right;
  padding: 10px 25px;
  border-top: 0;
  font-size: 14px;
  position: relative;
  margin-top: 0px;
}
.btnModifyTourDate {
  margin-right: 10px;
}
.Order-processing-detail-list {
  margin-bottom: 10px;
  font-size: 14px;
}
.locationWrong {
  margin: 16px 20px 20px;
  text-align: center;
  position: relative;
  /* z-index: 9999; */
}
.div-table {
  border: 1px solid #ccc;
  text-align: right;
  margin-top: -69px;
  padding: 10px 25px;
  border-top: 0;
  font-size: 14px;
}
.cardTitle {
  font-size: 16px;
  color: #4e81f0;
  margin: 42px 0 5px;
  font-weight: 600;
}
.amend-cardTitle {
  margin-bottom: 15px;
}
.ivu-btn-primary {
  background: none;
  color: #2d8cf0;
}
.ivu-breadcrumb > span:last-child {
  color: #4e81f0;
}

#customers {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  width: 100%;
  border-collapse: collapse;
  text-align: center;
  margin-top: 20px;
}

#customers td,
#customers th {
  border: 1px solid #e8eaec;
  padding: 10px;
  text-align: left;
}

#customers th {
  text-align: left;
  padding: 10px;
  background-color: #f8f8f9;
  color: #515a6e;
}

#customers tr.alt td {
  color: #000000;
  background-color: #eaf2d3;
}
.title-name {
  width: 100%;
  border: 1px solid #ccc;
  border-bottom: 0;
  text-align: center;
  padding: 8px 0;
  background-color: #f8f8f9;
  font-size: 14px;
}
.Order-processing-detail-list span {
  margin-right: 25px;
}
.amend-cardTitle a {
  margin-left: 20px;
}
.orderProcessingMoney {
  margin-right: 20px;
  display: inline-block;
}
</style>
